module.exports = __webpack_public_path__ + "img/btn-input-down.e879c9ed.svg";